export enum UsageEnum {
    MANDATORY = "MANDATORY",
    OPTIONAL = "OPTIONAL",
    NOT_USED = "NOT_USED"
}
